<template>
<div class="article-list-wrap">
  <section class="main-1">
    <section class="yf-thumb">当前位置：<nuxt-link to="/article">文章</nuxt-link> &gt; {{ $route.query.irSid | title(1) }}</section>
    <div class="container clearfix">
      <main class="left">
        <div class="header">{{ $route.query.irSid | title }}</div>
        <div class="article-list" v-if="$route.query.irSid === undefined">
          <YList :data="list" />
        </div>
        <div class="article-list" v-else>
          <div class="yf-news-list">
            <section class="news-list-content" v-for="item of list" :key="item.irSid">
              <div class="info clearfix">
                <h3 class="left ellipsis"><nuxt-link :to="`/article/detail/${item.irSid}?irSid=1`">{{ item.irUrltitle }}</nuxt-link></h3>
                <time class="right">{{ item.irLasttime }}</time>
              </div>
              <p class="intro">文章内容仅代表作者个人观点，仅供阅读交流，所有内容不构成投资建议，不作为买卖依据，据此操作风险自负!</p>
            </section>
          </div>
        </div>
        <!--分页-->
        <y-pager :total="total" />
      </main>
      <aside class="left">
        <section class="yf-recommend article" v-if="hotArticles.list.length">
          <p class="title" style="padding-bottom: 10px;">热门文章</p>
          <div class="item" v-for="item of hotArticles.list" :key="item.id">
            <p class="text_wrap ellipsis">
              <i></i>
              <nuxt-link :to="`/article/list/${item.userId}`">{{ item.userName }}</nuxt-link>| <nuxt-link :to="`/article/detail/${item.id}`" class="detail">{{ item.title }}</nuxt-link>
            </p>
            <p class="time_wrap yf-text_14">
              <span class="time">{{ item.createAt }}</span>
              <span class="number right">阅读<i>{{ item.viewCount }}</i></span>
            </p>
          </div>
        </section>
        <section class="yf-recommend author">
          <p class="title">
            <span>热门互动</span>
            <nuxt-link tag="span" to="/room">查看更多 &raquo;</nuxt-link>
          </p>
          <nuxt-link :to="`/room/${item.relationData.id}`" class="item clearfix live" v-for="item of $store.state.adList['hotRoom']" :key="item.id">
            <div class="item_left left">
              <img v-lazy="isSupportWebp(item.relationData.userAvatar)" :alt="item.relationData.userName"/>
            </div>
            <div class="item_right right">
              <p class="name_wrap clearfix">
                <span class="left">{{ item.relationData.userName }}</span>
                <span class="right" :class="{ 'yf-status-open': item.relationData.status === 11, 'yf-status-pause': item.relationData.status === 12, 'yf-status-close': item.relationData.status === 21 || item.relationData.status === undefined }"><nuxt-link :to="`/room/${item.relationData.id}`" target="_blank">{{ item.relationData.status | famousRoomStatus }}</nuxt-link></span>
              </p>
              <p class="detail ellipsis">{{ item.relationData.introduce }}</p>
            </div>
          </nuxt-link>
        </section>
        <!-- <section class="yf-recommend article" v-if="infos.length">
          <p class="title">
            <span>最新资讯</span>
            <span></span>
          </p>
          <div class="item" v-for="item of infos" :key="item.irSid" style="padding-bottom: 0;">
            <p class="text_wrap ellipsis">
              <i></i>
              <nuxt-link :to="`/article/detail/${item.irSid}?irSid=1`" class="detail">{{ item.irUrltitle }}</nuxt-link>
            </p>
            <p class="time_wrap yf-text_14" style="padding-left: 0;">
              <span class="time">{{ item.irLasttime }}</span>
            </p>
          </div>
        </section> -->
      </aside>
    </div>
  </section>
</div>
</template>

<script>
import Webp from '@/mixins/Webp'
import YList from '@/components/articles/List'
import { famousRoomStatus } from '~/utils/Filters'

export default {
  mixins: [Webp],
  watchQuery: ['page', 'num', 'irSid'],
  async asyncData ({ query, $axios }) {
    // 是否展示文章
    let isTitle = query.irSid === undefined
    
    let apiUrl = isTitle ? '/Article/List' : '/Information/OtherList'
    // let apiUrl = '/Article/List'
    let apiParams = {
      page: query.page || 1,
      num: query.num || process.env.DEFAULT_PAGE_SIZE
    }
    apiParams[`${isTitle ? 'service' : 'type'}`] = isTitle ? 1 : +query.irSid

    let { list, totalCount } = await $axios._get(apiUrl, apiParams)

    // 热门文章数据，暂时通过获取文章列表，后需要改成广告位再改
    let hotArticles = await $axios._get('/Article/List', { page: 1, num: 5, order: 'hot' })
    // 获取最新资讯
    let infos = await $axios._get('/Information/List')
    // console.log(hotArticles, infos)
    return {
      list,
      total: totalCount,
      hotArticles,
      infos
    }
  },
  mounted () {
    this.$store.dispatch('getAd', ['hotRoom'])
  },
  filters: {
    famousRoomStatus,
    title (v, type = 0) {
      switch (+v) {
        case 1:
          return '证券'
        case 2:
          return '国内财经'
        case 3:
          return '新股动态'
        case 4:
          return '港股'
        case 5:
          return '公司要闻'
        default:
          return type ? '所有文章列表' : '老师文章'
      }
    }
  },
  components: {
    YList
  }
}
</script>

<style lang="less">
.article-list-wrap {
  background-color: #e3e3e3; padding: 20px 0 30px;
  .container {
    main {
      .header {
        background-color: #f6f6f6; line-height: 60px; border-bottom: 1px solid #e3e3e3; padding-left: 38px; font-size: 20px;
      }
      .article-list {
        border-bottom: none;
        .item {
          &:last-child {
            border-bottom: 1px solid #eee;
          }
        }
      }
      .el-pagination {
        padding: 40px 0;
      }
    }
  }
}
</style>
